const POSTS_DOMAIN = 'posts'

export default POSTS_DOMAIN
